<template>
  <div v-if="camera">
    <div v-if="topicValue" class="image_container">
      <router-link :to="{path: '/cameras/' + camera.id}">
        <img :src="urlSnapshot" @load="loadHandler" @error="errorHandler" :style="imageStyle" class="image"/>
      </router-link>
    </div>
    <div v-else>No snapshot path provided.</div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import {randomInteger} from "../../utils/utils";
  import moment from 'moment';

  export default {
    name: "camera-viewer",
    props: ['camera'],
    data() {
      return {
        intervalFetchSnapshot: undefined,
        secondsBetweenFetches: 2,
        rand: moment().format('X'),
        isFailed: false
      };
    },
    computed: {
      ...mapGetters('mqtt', ['valueForTopic']),
      ...mapGetters('ui', ['windowSizes', 'cameraSmallViewSnapshotInterval']),
      topicValue() {
        if (this.camera && this.camera.topics) {
          let topicForSnapshot;
          this.camera.topics.forEach(item => {
            if (item.name === "snapshotUrl") {
              topicForSnapshot = item.topic;
            }
          });
          if (topicForSnapshot) {
            return this.valueForTopic(topicForSnapshot);
          }
        }

        return null;
      },
      snapshotInterval() {
        if (this.isFailed) {
          return this.secondsBetweenFetches * 10;
        }

        if (this.camera && this.camera.topics) {
          let topicForSnapshotInterval;
          this.camera.topics.forEach(item => {
            if (item.name === "snapshotInterval") {
              topicForSnapshotInterval = item.topic;
            }
          });
          if (topicForSnapshotInterval) {
            return this.valueForTopic(topicForSnapshotInterval);
          }
        }

        return this.secondsBetweenFetches;
      },
      urlSnapshot() {
        return `${this.topicValue}?r=${this.rand}`;
      },
      imageWidth() {
        const w = this.windowSizes['width'];
        if (w >= 768) {
          return 320;
        } else if (w >= 640) {
          return 320;
        } else if (w >= 500) {
          return 480;
        } else if (w >= 425) {
          return 320;
        } else if (w >= 375) {
          return 280;
        }

        return 240;
      },
      imageHeight() {
        return this.windowSizes['height'];
      },
      imageStyle() {
        return `width: ${this.imageWidth}px;`;
      }
    },
    methods: {
      ...mapActions('cameras', ['fetchSnapshot']),
      loadHandler() {
        if (this.isFailed) {
          this.isFailed = false;

          if (typeof this.intervalFetchSnapshot !== 'undefined') {
            clearInterval(this.intervalFetchSnapshot);

            this.intervalFetchSnapshot = setInterval(() => {
              this.rand = moment().format('X');
            }, this.snapshotInterval * 1000);
          }
        }

        if (typeof this.intervalFetchSnapshot === 'undefined') {
          this.intervalFetchSnapshot = setInterval(() => {
            this.rand = moment().format('X');
          }, this.snapshotInterval * 1000);
        }
      },
      errorHandler() {
        this.isFailed = true;

        if (typeof this.intervalFetchSnapshot !== 'undefined') {
          clearInterval(this.intervalFetchSnapshot);

          this.intervalFetchSnapshot = setInterval(() => {
            this.rand = moment().format('X');
          }, this.snapshotInterval * 1000);
        }
      }
    },
    mounted() {
      this.secondsBetweenFetches = this.cameraSmallViewSnapshotInterval + randomInteger(0, 9) / 100;
    },
    destroyed() {
      if (typeof this.intervalFetchSnapshot !== 'undefined') {
        clearInterval(this.intervalFetchSnapshot);
      }
    }
  }
</script>

<style scoped>
  .image_container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .image {
    border: solid 1px #000000;
  }
</style>